import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Table} from 'reactstrap';
import {toast} from 'react-toastify';
import {isEmpty} from 'lodash';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';

import ErrorMsg from "../common/ErrorMsg";

const heading_name_list = [
    'first_heading', 'second_heading', 'third_heading', 
    'forth_heading', 'fifth_heading'
];
const emptyRequestData = {
    id: 0,
    user_achievement: 0,
    added_on: '',
    first_heading: '',
    second_heading: '',
    third_heading: '',
    forth_heading: '',
    fifth_heading: '',
    request_note: ''
};

export default class RequestCorrectionModal extends Component {
    
    state = {
        requestData: {...emptyRequestData},
        requestList: []
    };

    componentDidMount = () => {
        this.getInitialState();
    };

    getInitialState = async () => {
        if (!(isEmpty(this.props.achievementSelected))) {
            try {
                let achievementData = {...this.props.achievementSelected};
                let addedOn = moment(achievementData.added_on, 'MM/DD/YYYY');
                // Commented out 
                // let periodStartDate = moment(this.props.periodStartDate);
                // if (periodStartDate > addedOn) {
                //     addedOn = moment(periodStartDate);
                // }
                let requestData = {
                    ...emptyRequestData,
                    user_achievement: achievementData.id,
                    added_on: addedOn,
                }
                this.setState({requestData});
            } catch (error) {
                console.log(error);
            }
        }
        try {
            const result = await this.props.getStaffCorrectionRequests();
            if (result) {
                let requestList = [];
                if (!(isEmpty(this.props.staffDashboard.requests))) {
                    requestList = this.props.staffDashboard.requests.map(
                        (request) => ({...request})
                    );
                }
                this.setState({requestList});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
        return false;
    };

    toggleModal = () => {
        let requestData = {...emptyRequestData};
        this.setState({requestData, requestList: []}, () => this.props.toggleModal());
    };

    handleChange = (e) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;
        let requestData = {...this.state.requestData};
        requestData[name] = value;
        this.setState({requestData});
    };

    handleFormattedData = (name, value) => {
        let requestData = {...this.state.requestData};
        requestData[name] = value;
        this.setState({requestData});
    };

    handleDateChangeRaw = (event) => {
        event.preventDefault();
    };

    handleDateChange = (date, field) => {
        if (field === "addedOn") {
            let requestData = {...this.state.requestData};
            requestData['added_on'] = date;
            this.setState({requestData});
        }
    };

    submitRequest = async () => {
        let requestData = {...this.state.requestData};
        requestData['added_on'] = moment(requestData.added_on).format("YYYY-MM-DD");
        try {
            const result = await this.props.postCorrectionRequest(requestData, this.props.staffDashboard.requests);
            if(result) {
                let newRequestData = {...emptyRequestData};
                this.setState({
                    requestData: newRequestData,
                    requestList: []
                });
                toast.success("Request Sent Successfully.");
                this.toggleModal();

                return true;
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
        return false;
    };

    render() {
        const {requestData, requestList} = this.state;
        const {headings, achievementSelected, viewCorrection, selectedKPI} = this.props;
        let headingList = [], dataList1 = [], dataList2 = [];
        let no_of_headings = headings.length;
        headings.map((heading, index) => {
            let heading_name = '';
            if (index < 5) {
                heading_name = heading_name_list[index];
            }
            headingList.push(
                <th className="border-0 font-weight-bold font-16 text-center" key={index}>
                    {heading.heading}
                </th>
            );
            dataList1.push(
                <td key={index} className="border-0 align-middle">
                    { heading.has_drop_down_enable && heading.drop_down_items.length > 0 ?
                        <select name={heading_name} className="form-control" 
                            value={achievementSelected[heading_name]} disabled={true}
                        >
                            <option value={''}></option>
                            {heading.drop_down_items.map((item, ind) => {
                                return (<option key={ind} value={item.item}>{item.item}</option>);
                            })}
                        </select>
                        : heading.has_property ? 
                            selectedKPI.data_type === "Currency" ?
                                <NumberFormat type="tel" 
                                    value={achievementSelected[heading_name]} 
                                    thousandSeparator={true} prefix={'$ '}  
                                    decimalScale={2} 
                                    className="form-control text-center" 
                                    name={heading_name} disabled={true} 
                                />
                                : selectedKPI.data_type === "Percentage" ?
                                    <NumberFormat type="tel" 
                                        value={achievementSelected[heading_name]} 
                                        thousandSeparator={true} suffix={' %'}  
                                        decimalScale={2} 
                                        className="form-control text-center " 
                                        name={heading_name} disabled={true} 
                                    />
                                    :
                                    <NumberFormat type="tel" 
                                        value={achievementSelected[heading_name]} 
                                        thousandSeparator={true} decimalScale={0} 
                                        className="form-control text-center " 
                                        name={heading_name} disabled={true} 
                                    />
                        :
                            <input name={heading_name} type="text" 
                                className="form-control text-center" 
                                value={achievementSelected[heading_name]} disabled={true} 
                            />
                    }
                </td>
            );
            dataList2.push(
                <td key={index} className="align-middle">
                    { heading.has_drop_down_enable && heading.drop_down_items.length > 0 ?
                        <select name={heading_name} className="form-control" 
                            onChange={this.handleChange} value={requestData[heading_name]}
                        >
                            <option key={0} value={''}>---Select---</option>
                            {heading.drop_down_items.map((item, ind) => {
                                return (<option key={ind} value={item.item}>{item.item}</option>);
                            })}
                        </select>
                        : heading.has_property ? 
                            selectedKPI.data_type === "Currency" ?
                                <NumberFormat type="tel" value={requestData[heading_name]} 
                                    thousandSeparator={true} prefix={'$ '}  
                                    decimalScale={2} allowNegative={false} 
                                    onValueChange={(values) => this.handleFormattedData(
                                        heading_name, values.floatValue)} 
                                    className="form-control text-center " name={heading_name}
                                />
                                : selectedKPI.data_type === "Percentage" ?
                                    <NumberFormat type="tel" value={requestData[heading_name]} 
                                        thousandSeparator={true} suffix={' %'}  
                                        decimalScale={2} allowNegative={false} 
                                        onValueChange={(values) => this.handleFormattedData(
                                            heading_name, values.floatValue)} 
                                        className="form-control text-center " 
                                        name={heading_name} 
                                    />
                                    :
                                    <NumberFormat type="tel" value={requestData[heading_name]} 
                                        thousandSeparator={true} decimalScale={0} 
                                        allowNegative={false} 
                                        onValueChange={(values) => this.handleFormattedData(
                                            heading_name, values.floatValue)} 
                                        className="form-control text-center " 
                                        name={heading_name} 
                                    />
                        :
                        <input name={heading_name} type="text" 
                            className="form-control text-center" 
                            onChange={this.handleChange} 
                            value={requestData[heading_name]} 
                        />
                    }
                </td>
            );
        });

        // Load request list
        let requestListData = [];
        requestListData = requestList.map((request, index) => {
            return (<tr key={index}>
                <td>{request.kpi_name}</td>
                <td>{request.requested_on}</td>
                <td>{request.added_on}</td>
                {
                    headings.map((heading, ind) => {
                        if (heading.has_property) {
                            if (selectedKPI.data_type === "Currency") {
                                return (<td key={ind} className="text-center" >
                                    <NumberFormat value={request[heading_name_list[ind]]} 
                                        thousandSeparator={true} prefix={'$ '}  
                                        decimalScale={2} displayType="text" 
                                        className="text-center" /></td>);
                            } else if (selectedKPI.data_type === "Percentage") {
                                return (<td key={ind} className="text-center" >
                                    <NumberFormat value={request[heading_name_list[ind]]} 
                                        thousandSeparator={true} suffix={' %'}  
                                        decimalScale={2} displayType="text" 
                                        className="text-center" /></td>);
                            } else {
                                return (<td key={ind} className="text-center" >
                                    <NumberFormat value={request[heading_name_list[ind]]} 
                                        thousandSeparator={true} displayType="text" /></td>);
                            }
                        } else {
                            return (<td key={ind} className="text-center" >
                                {request[heading_name_list[ind]]}</td>);
                        }
                    })
                }
            </tr>)
        });

        return (
            <Modal isOpen={this.props.modal} toggle={this.toggleModal} size="xl">
                <ModalHeader toggle={this.toggleModal}>
                    {viewCorrection ? 
                        "Outstanding Corrections" 
                        : "Request Correction Form"
                    }
                </ModalHeader>
                <ModalBody>
                    {viewCorrection ?
                        <Table responsive striped className="mb-0 bg-white border" size="sm">
                            <thead className="border-bottom bg-warning">
                                <tr>
                                    <th className="border-0 font-weight-bold font-16">
                                        KPI Name
                                    </th>
                                    <th className="border-0 font-weight-bold font-16">
                                        Requested on
                                    </th>
                                    <th className="border-0 font-weight-bold font-16">
                                        Date
                                    </th>
                                    {headingList}
                                </tr>
                            </thead>
                            <tbody>
                                {requestListData}
                            </tbody>
                        </Table>
                        : 
                        <Table responsive className="mb-0" size="sm">
                            <thead>
                                <tr>
                                    <th className="border-0 reqH1 font-weight-bold font-16"></th>
                                    <th className="border-0 reqH2 font-weight-bold font-16 text-center">
                                        Date
                                    </th>
                                    {headingList}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border-0 align-middle font-weight-bold">Current Info</td>
                                    <td className="border-0 align-middle  font-weight-bold">
                                        <input name="added_on" type="text"  
                                            className="form-control" 
                                            value={achievementSelected.added_on} 
                                            disabled={true} 
                                        />
                                    </td>
                                    {dataList1}
                                </tr>
                                <tr>
                                    <td className="align-middle font-weight-bold">
                                        Requested Change
                                    </td>
                                    <td className="align-middle font-weight-bold">
                                        <div className="div-datepicker">
                                            <DatePicker
                                                selected={requestData.added_on}
                                                onChangeRaw={this.handleDateChangeRaw}
                                                onChange={(event) => this.handleDateChange(event, "addedOn")}
                                                dateFormat="MM/DD/YYYY"
                                                fixedHeight
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                className="form-control"
                                                placeholderText="Date (mm/dd/yyyy)"
                                                minDate={moment(this.props.periodStartDate)}
                                                maxDate={moment()}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </td>
                                    {dataList2}
                                </tr>
                                <tr>
                                    <td className="border-0 align-middle font-weight-bold">
                                        Notes
                                    </td>
                                    <td className="border-0 align-middle" 
                                        colSpan={no_of_headings+1}
                                    >
                                        <Input type="textarea" name="request_note" rows="3" 
                                            value={requestData.request_note} 
                                            onChange={this.handleChange} 
                                            placeholder="Enter Notes" 
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </Table> 
                    }
                </ModalBody>
                <ModalFooter>
                    {
                        viewCorrection ? null 
                        : 
                        <Button className='btn btn-success' onClick={this.submitRequest}>
                            Submit
                        </Button>
                    }
                    <Button className='btn btn-secondary' onClick={this.toggleModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/staffDashboard/RequestCorrectionModal.js